import axios from 'axios';

/**
 * Returns a Shopify URL that contains a Multipass token to auto-authenticate
 * The current user in the Shopify checkout page.
 *
 * @param {Object} param
 * @param {string} param.accessToken - Shopify user access token
 * @param {string} param.returnTo - return to URL
 * @returns {string} Shopify checkout URL with a multipass token
 */
export const generateUrl = async ({ accessToken, returnTo }) => {
  const data = await axios.post('/.netlify/functions/api/shopify/multipass', {
    accessToken,
    returnTo,
  });

  return data;
};
